module.exports = __webpack_public_path__ + "static/getconf2019-80b86864378e7f085399c494db677093.jpg";